export enum ExcelExportType {
  Comments = "comments",
  Responses = "responses",
  Participation = "participation",
  Ranking = "ranking",
}
